import { IconButton, Stack, Typography } from '@mui/material';
import type { CustomerPortalCustomer } from '@vy/types';
import { VyDivider } from '../../../../../components/new-design/atoms';
import { VyTooltip } from '../../../../../components/new-design/VyTooltip';
import { UsageChartIcon } from '@vy/ui-design-system';

type CustomerPortalCustomerDetailsProps = {
  customer: CustomerPortalCustomer;
  onUsageClick?: () => void;
};

export const CustomerPortalCustomerDetails: React.FC<CustomerPortalCustomerDetailsProps> = ({
  customer,
  onUsageClick,
}) => {
  return (
    <Stack>
      <Stack spacing={2} direction="row" sx={{ alignItems: 'center' }}>
        <Stack
          direction="row"
          divider={<VyDivider orientation="vertical" flexItem />}
          sx={{ alignItems: 'center', gap: 2 }}
        >
          <VyTooltip tooltipContent={customer.name} placement="top" arrow>
            <Typography
              variant="h5"
              sx={{ fontSize: '24px', minWidth: 'max-content', overflowWrap: 'break-word' }}
            >
              {formatCustomerName(customer.name)}
            </Typography>
          </VyTooltip>

          <Typography color="text.secondary" sx={{ fontSize: '24px', fontWeight: 300 }}>
            Invoice portal
          </Typography>
        </Stack>

        {onUsageClick && (
          <VyTooltip tooltipContent="View usage breakdown" placement="top" arrow>
            <IconButton data-vy="customer-portal-view-usage-button" size="small" onClick={onUsageClick}>
              <UsageChartIcon />
            </IconButton>
          </VyTooltip>
        )}
      </Stack>
      <Typography variant="body1" color="textSecondary" sx={{ fontWeight: 300 }}>
        View your usage, credit and invoices
      </Typography>
    </Stack>
  );
};

function formatCustomerName(name: string) {
  return name.length > 35 ? `${name.substring(0, 35)}...` : name;
}
